import { ITask } from '@/types/task.interface'

export const sortTasksByAdded = (tasks: ITask[]) => {
	if (!tasks) return []

	return [...tasks].sort(
		(a, b) => new Date(b.added_at).getTime() - new Date(a.added_at).getTime()
	)
}
